import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";

import DisneyButton from "./DisneyButton";
import PenImage from "./PenImage";

export default function PenPicker({ onClose }: { onClose?: () => void }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="relative flex h-11 w-full items-center justify-center">
        <Text lg>{t("chooseYourMagicPen")}</Text>

        {onClose ? (
          <Touchable
            className="absolute right-0 top-0 mx-4 my-2.5"
            onClick={onClose}
          >
            <X className="size-6" />
          </Touchable>
        ) : null}
      </div>

      <div className="flex w-full max-w-[480px] flex-col gap-6">
        <div className="flex h-[270px] justify-around px-10">
          <PenImage type="mickey" />
          <PenImage type="minnie" />
        </div>

        <div className="flex h-[54px] justify-around px-9">
          <DisneyButton type="mickey" />
          <DisneyButton type="minnie" />
        </div>
      </div>
    </>
  );
}
